module.exports = __webpack_public_path__ + "img/logoFidelmira.27e0244f.jpg";